import { useQuery } from '@tanstack/react-query';

import { LocalEnvironmentResponse } from '@telialt/models/src/EshopModel';
import { axiosForHybris } from '@telialt/utils/src/axios/axiosForHybris';
import { withParams } from '@telialt/utils/src/helpers';
import { useSiteName } from '@telialt/utils/src/segment';

import { API } from '../store/constants';

export const apiGetIsLocalEnvironment = async (siteName: string) =>
    (await axiosForHybris.get<LocalEnvironmentResponse>(withParams(API.URL_IS_LOCAL_ENV, { siteName }))).data;

export const useIsLocalEnvironment = () => {
    const siteName = useSiteName();

    const { data } = useQuery({
        queryKey: ['LOCAL', siteName],
        queryFn: () => apiGetIsLocalEnvironment(siteName),
        select: ({ isLocal }) => isLocal,
    });

    return data;
};
